import { createReducer } from '@reduxjs/toolkit';
import {
    ADD_JOURNALIST_NEWS,
    SET_IS_LOADING_NEWS,
    SET_IS_LOADING_DATA,
    SET_JOURNALISTS_DATA,
} from '../actions/journalistsActions';

const initialState = {
    journalistsData: [],
    isLoadingNews: true,
    isLoadingData: true,
    currentSlug: false,
};

const journalists = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_JOURNALISTS_DATA, (state, action) => {
            state.journalistsData = action.journalistsData;
        })
        .addCase(ADD_JOURNALIST_NEWS, (state, action) => {
            const journalist = state.journalistsData.find((currentJournalist) => currentJournalist.id === action.id);

            if (journalist) {
                journalist.news = journalist.news.concat(action.news);
            }

            state.isLoadingNews = false;
        })
        .addCase(SET_IS_LOADING_DATA, (state, action) => {
            state.isLoadingData = action.isLoading;
        })
        .addCase(SET_IS_LOADING_NEWS, (state, action) => {
            state.isLoadingNews = action.isLoading;
        });
});

export default journalists;
